import React, {Component} from 'react';
import {Checkbox, Button} from "antd/lib/index";
import {connect} from "react-redux";
import queryString from "query-string";
import {castArray, includes, map, range} from "lodash";
import {urlFiltersParser, updateUrlFilter} from 'utils';
import _ from "i18n";
import {setStatisticsApplicationFilter, setStatisticsEventsFilter} from "../../../actions/actions"
import {Table, Menu, Dropdown, Icon, message, Card} from "antd";
import __ from "lodash";
import StatisticAppTypeFilter from "./StatisticAppTypeFilter";

class DocumentApplicationFilters extends Component
{
  constructor(props) {
    super(props);

    this.defaultCheckedList = ['EVENT'];

    this.plainOptions = [
      'EVENT',
      'UA',
      'PAPER',
    ];

    this.state = {
      checkedList: this.initFromFilter(),
    };
  }

  componentDidMount() {

    const filter = this.initFromFilter();
    const checkedList = __.uniq([...this.props.statisticsFilter.apps, ...filter]);

    this.setState({checkedList});

    updateUrlFilter('app', 'in', checkedList);


    this.props.setStatisticsApplicationFilter(checkedList);
  }


  componentDidUpdate(prevProps, prevState) {
    if(prevProps.statisticsFilter.apps !== this.props.statisticsFilter.apps) {
      this.setState({checkedList : this.props.statisticsFilter.apps});
    }

  }

  initFromFilter = () => {
    const urlParams   = queryString.parse(location.search);

    if(!urlParams.filters) {
      return this.defaultCheckedList;
    }

    let filter = urlFiltersParser(urlParams.filters);

    if(!filter || filter.length <= 0) {
      return this.defaultCheckedList;
    }

    let periodFilter = filter.filter(item => 'app' === item.property);
    if(!periodFilter || periodFilter.length <= 0 || !periodFilter[0].value) {
      return this.defaultCheckedList;
    }

    return castArray(periodFilter[0].value);
  };

  onChange = (checkedList) => {
    this.setState({checkedList});
    this.props.setStatisticsApplicationFilter(checkedList);
  };

  toggleDescriminantChecked = (event) => {
    let operation = event.target.dataset.operation;
    let {checkedList} = this.state;

    checkedList = checkedList.includes(operation) ?
      checkedList.filter(item => item !== operation) :
      [...checkedList, operation];

    this.setState({checkedList});
    this.props.setStatisticsApplicationFilter(checkedList);

    updateUrlFilter('app', 'in', checkedList);

  };

  render() {

    return (<div>

      {/* <div className="hidden">
        <Checkbox.Group options={this.plainOptions} value={this.state.checkedList} onChange={this.onChange}/>
      </div>
        <nav>
        <Button  type={this.state.checkedList.includes('EVENT') ? 'primary' : 'default'} data-operation="EVENT" onClick={this.toggleDescriminantChecked}>{_('EVENT')}
          {this.state.checkedList.includes('EVENT') ?
            <Icon type="close"/> : null}
        </Button>
        <Button  type={this.state.checkedList.includes('UA') ? 'primary' : 'default'} data-operation="UA" onClick={this.toggleDescriminantChecked}>{_('UA')}

          {this.state.checkedList.includes('UA') ?
            <Icon type="close"/> : null}

        </Button>
        <Button  type={this.state.checkedList.includes('PAPER') ? 'primary' : 'default'} data-operation="PAPER" onClick={this.toggleDescriminantChecked}>{_('PAPER')}
          {this.state.checkedList.includes('PAPER') ?
            <Icon type="close"/> : null}
        </Button>
        </nav> */}


    </div>);
  }
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter
});

const mapDispatchToProps = {
  setStatisticsApplicationFilter,
  setStatisticsEventsFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentApplicationFilters);



// WEBPACK FOOTER //
// ./app/components/Filters/Statistics/DocumentApplicationFilters.js